import './cartItemStyles.scss'
import { TrashIcon } from '@quickmd-llc/design-system'
import { PharmacyPartners } from 'components/product-order-popup/common'
import { useProductOrderContext } from 'components/product-order-popup/context'
import { selectAsyncRefillsPhase1Flag } from 'store/flags/FlagsSelectors'
import { type CartItem as Item } from 'types/products/productTypes'
import { useSelector } from 'store/hooks/useSelector'
import { pluralize } from '@quickmd-llc/frontend-utils'

type Props = {
  item: Item
}

export const CartItem = ({ item }: Props) => {
  const { deliveryType, setCartItems, pharmacyPartnerType, isMHT, isMHTHomeDelivery } = useProductOrderContext()
  const removeFromCart = () => {
    setCartItems((prev) => prev.filter((cartItem) => cartItem.CartId !== item.CartId))
  }
  const selectedPharmacyPartnerTitle = PharmacyPartners.getPharmacyPartnerTitle(pharmacyPartnerType)

  const asyncRefillsPhase1IsEnabled = useSelector(selectAsyncRefillsPhase1Flag)

  return (
    <div className='cart-item-container'>
      <div className='cart-item-info-container'>
        <div className='cart-item-title-container'>
          <div className='cart-item-title'>
            {/*
             // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered */}
            {item.Order.Name} - {item.Order.ShortName}
          </div>
          {deliveryType === 'home' && (
            // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
            <div className='cart-item-title'>{`$${Number(item.Order.Price.toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2 })}`}</div>
          )}
        </div>
        {selectedPharmacyPartnerTitle ? <div className='cart-item-subtitle'>{selectedPharmacyPartnerTitle}</div> : null}

        {asyncRefillsPhase1IsEnabled && isMHTHomeDelivery ? <div className='cart-item-sig'>
            {item.RefillsQuantity ?
              `${item.RefillsQuantity} ${pluralize('refill', item.RefillsQuantity)}`
            : 'No refills'}
          </div> : null}
        {/*
         // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered */}
        {!isMHT && <div className='cart-item-sig'>{item.Order.ShortName}</div>}

        <div className='cart-item-sig'>Sig: {item.Signature}</div>
      </div>
      <div className='cart-item-actions-container'>
        <TrashIcon style={{ color: '#CB4D25', cursor: 'pointer' }} onClick={removeFromCart} />
      </div>
    </div>
  )
}
